import { MIN_SCREEN_HEADER_HEIGHT } from '@components/v2/constants';
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { MediaFormatEnum } from '../../../modules/general-settings/enums/mediaFormat.enum';
import { contentNotificationImageWidth } from '../ProductAddNotification';

type ProductNotificationStylesProps = {
  mediaFormat?: MediaFormatEnum;
};

const SNACKBAR_SHADOW_OPACITY = 0.15;
const AVATAR_BORDER_RADIUS = 8;

export const useProductNotificationStyles = makeStyles<ProductNotificationStylesProps>()(
  (theme, { mediaFormat }) => {
    const surface = {
      marginTop: MIN_SCREEN_HEADER_HEIGHT,
      borderRadius: 16,
      border: `1px solid ${theme.palette.custom.border.primary}`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: `0px 1px 16px 1px ${alpha(theme.palette.common.black, SNACKBAR_SHADOW_OPACITY)}`,
      display: 'flex',
      padding: theme.spacing(0, 2),
    };

    return {
      colorButton: {
        [theme.breakpoints.down('lg')]: { display: 'flex' },
      },
      cursor: {
        fontSize: '12px',
        cursor: 'pointer',
      },
      snackbar: {
        ...surface,
        width: 363,
        height: 158,
      },
      colorName: {
        paddingLeft: theme.spacing(0.75),
      },
      productAlreadySnackbar: {
        ...surface,
        width: 380,
        height: 60,
      },
      avatarContainer: {
        width: mediaFormat ? contentNotificationImageWidth[mediaFormat] : undefined,
        borderTopLeftRadius: AVATAR_BORDER_RADIUS,
        borderBottomLeftRadius: AVATAR_BORDER_RADIUS,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,

        '& > img': {
          borderRadius: 0,
        },
      },
    };
  },
);
